<div class="form-wrap flex-row" *ngIf="!isUserDataSearchOpen" (click)="isUserDataSearchOpen = !isUserDataSearchOpen">
	<span>{{ labels.lbl_buscar_dados_usuario }}</span>
	<span><fa-icon [icon]="icons.faAngleDown"></fa-icon></span>
</div>
<div class="form-wrap" *ngIf="isUserDataSearchOpen">
	<div class="flex-row" (click)="isUserDataSearchOpen = !isUserDataSearchOpen">
		<span>{{ labels.lbl_buscar_dados_usuario }}</span>
		<span><fa-icon [icon]="icons.faAngleUp"></fa-icon></span>
	</div>
	<cpi-generic-form-gen [setGenericForm]="searchUserForm" [columns]="1" [labels]="labels" [boldLabel]="false" (input)="(null)">
	</cpi-generic-form-gen>
	<div class="button-container">
		<span></span>
		<div class="button" (click)="getUserData()">
			{{ labels.lbl_geral_buscar }}
			<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isLoadingUserDataSearch"></cpi-dot-bounce-loading-effect>
		</div>
	</div>

	<cpi-input-with-autocomplete
		[availableOptions]="searchUserData"
		[minInputLength]="0"
		[placeholder]="labels.lbl_geral_pesquisar"
		(onValueChange)="selectedUser = searchUserDictionary[$event]"
		*ngIf="searchUserData.length > 0">
	</cpi-input-with-autocomplete>

	<div class="form-wrap" *ngIf="selectedUser != undefined">
		<div class="dotted-input-container">
			<span>{{ labels.lbl_geral_cliente }}</span> <input class="disabled" [value]="ProfileService.userData().customer" disabled />
		</div>
		<div class="dotted-input-container">
			<span>{{ labels.lbl_geral_nome }}</span
			><input class="disabled" [value]="selectedUser.fullName ? selectedUser.fullName : ''" disabled />
		</div>
		<div class="dotted-input-container">
			<span>{{ labels.lbl_geral_email }}</span
			><input class="disabled" [value]="selectedUser.email ? selectedUser.email : ''" disabled />
		</div>
		<div class="dotted-input-container">
			<span>{{ labels.lbl_geral_login }}</span
			><input class="disabled" [value]="selectedUser.login ? selectedUser.login : ''" disabled />
		</div>
		<div class="dotted-input-container">
			<span>{{ labels.lbl_chave_unica }}</span
			><input class="disabled" [value]="selectedUser.uniquekey ? selectedUser.uniquekey : ''" disabled />
		</div>
		<div class="dotted-input-container">
			<span>{{ labels.lbl_geral_telefone }}</span
			><input class="disabled" [value]="selectedUser.phone ? selectedUser.phone : ''" disabled />
		</div>
	</div>
</div>
